import { $streemApiV1 } from "shared/boot/api";
import { constantize } from "shared/helpers/string";

function getExcludedMentions(stream, options = {}) {
  const params = { excerpt_radius: 60, ...options };

  return $streemApiV1.get(`streams/${stream.id}/excluded_mentions`, { params });
}

async function loadExcludedMentionsCount(stream) {
  const response = await getExcludedMentions(stream, { limit: 0, page: 1 });

  return Number(response.headers["x-total-count"]);
}

function removeExcludedMention(stream, mention) {
  const params = {
    target_id: mention.id,
    target_type: constantize(mention.type),
  };

  return $streemApiV1.delete(`streams/${stream.id}/excluded_mention`, {
    params,
  });
}

function removeMention(stream, mention) {
  const params = {
    comment: mention.comment,
    target_id: mention.id,
    target_type: constantize(mention.type),
  };

  return $streemApiV1.post(`streams/${stream.id}/exclude_mention`, { params });
}

export {
  getExcludedMentions,
  loadExcludedMentionsCount,
  removeExcludedMention,
  removeMention,
};
